/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import { ClipLoader } from "react-spinners";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
/* Styles */
import styles from "./styles.js"

const Spinner = ({size, color, customClass}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={ `${classes.spinner} ${customClass}`}>
      <ClipLoader size={size} color={color}/>
    </div>
  )
}

export default Spinner;
